// extracted by mini-css-extract-plugin
export default {"main-layout":"MainLayout_main-layout__y9dDB","inner-sidebar-visible":"MainLayout_inner-sidebar-visible__cEHw9"};